import React from "react";

const HeaderLogo = () => {
  const color = "#22c55e"; // Neon Green

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
      {/* THE MASTER ICON (House-H) */}
      <div
        style={{
          width: "32px",
          height: "32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <svg
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            filter: `drop-shadow(0 0 4px ${color}60)`,
            width: "100%",
            height: "100%",
          }}
        >
          <path
            d="M10 35 L50 10 L90 35"
            stroke={color}
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M70 22 V12 H80 V28"
            stroke={color}
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28 35 V90"
            stroke={color}
            strokeWidth="10"
            strokeLinecap="square"
          />
          <path
            d="M72 35 V90"
            stroke={color}
            strokeWidth="10"
            strokeLinecap="square"
          />
          <path
            d="M20 90 H36 M64 90 H80 M20 35 H36 M64 35 H80"
            stroke={color}
            strokeWidth="6"
            strokeLinecap="round"
          />
          <line
            x1="15"
            y1="62"
            x2="85"
            y2="62"
            stroke={color}
            strokeWidth="6"
            strokeLinecap="round"
          />
          <rect
            x="15"
            y="52"
            width="6"
            height="20"
            rx="2"
            stroke={color}
            strokeWidth="4"
          />
          <rect
            x="79"
            y="52"
            width="6"
            height="20"
            rx="2"
            stroke={color}
            strokeWidth="4"
          />
        </svg>
      </div>

      {/* THE BRAND TEXT */}
      <div
        style={{
          fontFamily: "'Inter', sans-serif",
          lineHeight: "1",
          display: "flex",
          alignItems: "center",
          gap: "6px", // Tight gap between words
        }}
      >
        <span
          style={{
            fontWeight: "800",
            color: "#fff",
            fontSize: "18px",
            letterSpacing: "1px",
          }}
        >
          SIMPLER
        </span>
        <span
          style={{
            fontFamily: "monospace",
            color: color,
            fontSize: "18px", // Match size for balance
            fontWeight: "700",
            letterSpacing: "1px",
          }}
        >
          HEALTH
        </span>
      </div>
    </div>
  );
};

export default HeaderLogo;
